/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Email_CrumbInputs */

const en_auth_verify_email_crumb = /** @type {(inputs: Auth_Verify_Email_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify email`)
};

/**
* | output |
* | --- |
* | "Verify email" |
*
* @param {Auth_Verify_Email_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_verify_email_crumb = /** @type {((inputs?: Auth_Verify_Email_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Email_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_verify_email_crumb(inputs)
});